import { render } from "./404.vue?vue&type=template&id=2d475d98&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2d475d98"

export default script